<ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
@if (isZpcSyncWarningPresent()) {
  <div>
    <legend data-automation="fieldset-header-legend">
      {{ 'tkey;shared.model.microsoft_teams_calling.ad_attributes.header' | translate }}
    </legend>
    <div class="alert alert-warning d-flex justify-content-between">
      <span>
        <i [ngClass]="ziroIcons.WARNING_TRIANGLE"></i>
        <strong data-automation="ad-attribute-warning-banner-text">
          {{ 'tkey;shared.model.microsoft_teams_calling.ad_attributes.warning_banner.text' | translate }}
        </strong>
      </span>
    </div>
  </div>
}
@if (isAnyAttributeVisible) {
  <div>
    @if (!isLoading && !isZpcSyncWarningPresent()) {
      <div>
        <ziro-helpdesk-ad-attributes-form
          (ziroFormsUpdate$)="onChildFormUpdate($event)"
          [formConfig]="formConfig"
          [attributeFields]="attributeFields"
          [initialEntity]="initialEntity"
        ></ziro-helpdesk-ad-attributes-form>
      </div>
    }
  </div>
}
